import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const PageHeader = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '400px',
  width: '100%',
  display: 'flex',
  alignItems: 'flex-end',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1
  }
}));

const BackgroundImage = styled('img')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover'
});

const TitlePage = ({ title, image }) => {
  return (
    <PageHeader>
      <BackgroundImage src={image} alt={title} />
      <Container 
        maxWidth="xl"
        sx={{
          position: 'relative',
          zIndex: 2,
          px: { xs: 2, sm: 4, md: 8, lg: 12 },
          pb: 6
        }}
      >
        <Typography 
          variant="h1" 
          sx={{ 
            color: '#FFFFFF',
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            fontWeight: 700,
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
          }}
        >
          {title}
        </Typography>
      </Container>
    </PageHeader>
  );
};

export default TitlePage;
